module.exports = __webpack_public_path__ + "img/jyb-android.921d2f3b.png";